"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = void 0;

var _isDefined = require("../misc-checks/isDefined");

var isFunction = function isFunction(targetFunction) {
  return (0, _isDefined.isDefined)(targetFunction) && typeof targetFunction === "function";
};

exports.isFunction = isFunction;